(function(){
  var state = { step: 1, answers: {} };
  var TOTAL = 6;
  var finder = document.getElementById('ef-fireplace-finder');
  if(!finder) return;

  var dots = finder.querySelectorAll('.ef-ff__dot');
  var steps = finder.querySelectorAll('.ef-ff__step');
  var backBtn = document.getElementById('ef-ff-back');
  var progress = finder.querySelector('.ef-ff__progress');

  // Stany bez vent-free (zakaz stanowy)
  var VF_BANNED = { CA: 'California', MA: 'Massachusetts' };
  var STATES = 'AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI WY DC'.split(' ');

  var indexData = null;
  fetch(window.EF_FF_INDEX_URL)
    .then(function(r){ return r.json(); })
    .then(function(d){ indexData = d; })
    .catch(function(){ indexData = { fireplaces: [] }; });

  // Restore
  try {
    var saved = sessionStorage.getItem('ef_fireplace_finder');
    if(saved) state = JSON.parse(saved);
  } catch(e){}

  function save(){
    try { sessionStorage.setItem('ef_fireplace_finder', JSON.stringify(state)); } catch(e){}
  }

  function track(ev, data){
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: ev, wizard: 'fireplace-finder' }, data || {}));
    } catch(e){}
  }

  // Kroki pomijane zależnie od odpowiedzi:
  // outdoor -> bez ventingu (2) i stanu (3); vent=direct-vent/insert -> bez stanu (3)
  function skipped(step){
    var a = state.answers;
    if(step === 2 && a.location === 'outdoor') return true;
    if(step === 3){
      if(a.location === 'outdoor') return true;
      if(a.vent === 'direct-vent' || a.vent === 'insert') return true;
    }
    return false;
  }

  function nextFrom(step){
    var n = step + 1;
    while(n <= TOTAL && skipped(n)) n++;
    return n > TOTAL ? 'results' : n;
  }
  function prevFrom(step){
    var p = (step === 'results' ? TOTAL : step - 1);
    while(p >= 1 && skipped(p)) p--;
    return p < 1 ? 1 : p;
  }

  function goTo(step){
    state.step = step;
    save();
    steps.forEach(function(s){ s.classList.remove('ef-ff__step--active'); });
    var target = finder.querySelector('[data-step="' + step + '"]');
    if(target) target.classList.add('ef-ff__step--active');

    dots.forEach(function(d, i){
      d.classList.remove('ef-ff__dot--active','ef-ff__dot--done');
      if(step === 'results') d.classList.add('ef-ff__dot--done');
      else {
        if(i < step - 1) d.classList.add('ef-ff__dot--done');
        if(i === step - 1) d.classList.add('ef-ff__dot--active');
      }
    });
    if(progress) progress.setAttribute('aria-valuenow', step === 'results' ? TOTAL : step);
    backBtn.style.display = (step === 1) ? 'none' : 'flex';

    if(step === 'results') showResults();
    else track('wizard_step', { step: step });
    window.scrollTo({ top: finder.offsetTop - 20, behavior: 'smooth' });
  }

  function selectOption(key, value){
    state.answers[key] = value;
    save();
    var stepEl = finder.querySelector('.ef-ff__step--active');
    stepEl.querySelectorAll('.ef-ff__card').forEach(function(c){ c.classList.remove('ef-ff__card--selected'); });
    var sel = stepEl.querySelector('[data-key="' + key + '"][data-value="' + value + '"]');
    if(sel) sel.classList.add('ef-ff__card--selected');
    setTimeout(function(){
      goTo(nextFrom(typeof state.step === 'number' ? state.step : TOTAL));
    }, 350);
  }

  finder.addEventListener('click', function(e){
    var card = e.target.closest('[data-key][data-value]');
    if(card) selectOption(card.dataset.key, card.dataset.value);
  });

  backBtn.addEventListener('click', function(){
    goTo(prevFrom(state.step));
  });

  // Krok 2: edukacja
  var learnBtn = document.getElementById('ef-ff-vent-learn');
  var learnContent = document.getElementById('ef-ff-vent-content');
  if(learnBtn) learnBtn.addEventListener('click', function(){
    learnContent.style.display = learnContent.style.display === 'none' ? 'block' : 'none';
  });

  // Krok 3: stan
  var stateSel = document.getElementById('ef-ff-state');
  var stateWarn = document.getElementById('ef-ff-state-warn');
  var stateNext = document.getElementById('ef-ff-state-next');
  var stateSkip = document.getElementById('ef-ff-state-skip');
  if(stateSel){
    STATES.forEach(function(s){
      var o = document.createElement('option');
      o.value = s; o.textContent = s + (VF_BANNED[s] ? ' — vent-free not permitted' : '');
      stateSel.appendChild(o);
    });
    stateSel.addEventListener('change', function(){
      var v = stateSel.value;
      state.answers.state = v;
      save();
      stateNext.disabled = !v;
      stateWarn.style.display = (v && VF_BANNED[v]) ? 'block' : 'none';
    });
  }
  if(stateNext) stateNext.addEventListener('click', function(){ goTo(nextFrom(3)); });
  if(stateSkip) stateSkip.addEventListener('click', function(){
    state.answers.state = '';
    save();
    goTo(nextFrom(3));
  });

  var restart = document.getElementById('ef-ff-restart');
  if(restart) restart.addEventListener('click', function(){
    state = { step: 1, answers: {} };
    try { sessionStorage.removeItem('ef_fireplace_finder'); } catch(e){}
    goTo(1);
  });

  // --- Dopasowanie ---
  var BUDGET = { low: [0, 2500], mid: [2500, 4000], high: [4000, 99999] };

  function ventAllowed(a){
    // vent-free wykluczony w stanach z zakazem
    return !(a.state && VF_BANNED[a.state]);
  }

  function wantedVents(a){
    if(a.location === 'outdoor') return null; // outdoor: nie filtrujemy po vencie
    if(a.vent === 'direct-vent') return ['direct-vent'];
    if(a.vent === 'insert') return ['insert'];
    if(a.vent === 'vent-free') return ventAllowed(a) ? ['vent-free'] : ['direct-vent'];
    if(a.vent === 'notsure') return ventAllowed(a) ? ['direct-vent','vent-free','insert'] : ['direct-vent','insert'];
    return null;
  }

  function score(p, a){
    var s = 0;
    // lokalizacja — twardy filtr
    if(a.location && p.location !== a.location) return -1;
    // vent
    var vents = wantedVents(a);
    if(vents){
      if(!p.vent) s -= 8; // brak danych: nie wykluczaj, ale niżej
      else if(vents.indexOf(p.vent) === -1) return -1;
      else s += 25;
    }
    // szerokość
    if(a.width && a.width !== 'any' && p.width){
      var w = Number(a.width);
      var lo, hi;
      if(w === 32){ lo = 26; hi = 34; }
      else if(w === 36){ lo = 35; hi = 38; }
      else if(w === 42){ lo = 40; hi = 45; }
      else { lo = 46; hi = 120; }
      if(p.width >= lo && p.width <= hi) s += 30;
      else if(p.width >= lo - 4 && p.width <= hi + 4) s += 12;
    }
    // styl
    if(a.style && a.style !== 'any'){
      if(p.style === a.style) s += 20;
    }
    // budżet
    if(a.budget && a.budget !== 'any' && p.price){
      var b = BUDGET[a.budget];
      if(p.price >= b[0] && p.price < b[1]) s += 20;
      else if(p.price >= b[0] * 0.85 && p.price < b[1] * 1.15) s += 8;
    }
    // popularność
    s += (p.pop || 0);
    return s;
  }

  var VENT_LABEL = {
    'direct-vent': 'Direct Vent', 'vent-free': 'Vent-Free', 'insert': 'Insert',
    'vented-outdoor': 'Vented', 'wood': 'Wood-Burning'
  };

  function cardHTML(p){
    var badges = [];
    if(p.width) badges.push(p.width + '"');
    if(p.vent && VENT_LABEL[p.vent]) badges.push(VENT_LABEL[p.vent]);
    if(p.btu) badges.push((p.btu / 1000) + 'k BTU');
    if(p.fuels && p.fuels.length > 1) badges.push('NG / LP');
    var badgeHtml = badges.map(function(b){ return '<span class="ef-ff__badge">' + b + '</span>'; }).join('');
    return '<div class="ef-ff__result-card">' +
      (p.image ? '<img src="' + p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=400" alt="" loading="lazy">' : '<div class="ef-ff__result-noimg"></div>') +
      '<div class="ef-ff__result-info">' +
        '<h3>' + p.title + '</h3>' +
        '<div class="ef-ff__badges">' + badgeHtml + '</div>' +
        '<div class="ef-ff__result-price">From $' + p.price.toLocaleString('en-US') + '</div>' +
        '<a href="/products/' + p.handle + '">View &amp; Configure</a>' +
      '</div></div>';
  }

  function showResults(){
    var resultsDiv = document.getElementById('ef-ff-results');
    var note = document.getElementById('ef-ff-results-note');
    if(!resultsDiv) return;

    function render(){
      var a = state.answers;
      var all = (indexData && indexData.fireplaces) || [];
      var showDrafts = /[?&]show=all/.test(location.search);
      var pool = all.filter(function(p){ return p.status === 'ACTIVE'; });
      if(pool.length === 0 || showDrafts) pool = all; // katalog w budowie / preview

      var scored = pool.map(function(p){ return { p: p, s: score(p, a) }; })
        .filter(function(x){ return x.s >= 0; })
        .sort(function(x, y){ return y.s - x.s; });

      var top = scored.slice(0, 6);
      track('wizard_complete', { answers: a, results: top.length });

      if(a.state && VF_BANNED[a.state] && (a.vent === 'vent-free' || a.vent === 'notsure')){
        note.textContent = 'Vent-free models are not permitted in ' + VF_BANNED[a.state] + ', so we matched you with direct vent fireplaces instead.';
      } else if(a.vent === 'notsure'){
        note.textContent = 'Showing both direct vent and vent-free matches — each product page explains its venting in plain English.';
      } else {
        note.textContent = '';
      }

      if(top.length === 0){
        track('wizard_no_results', { answers: a });
        resultsDiv.innerHTML = '<div class="ef-ff__empty">' +
          '<p><strong>No exact matches for this combination in our catalog right now.</strong></p>' +
          '<p>Tell our support team what you need — we\'ll match you personally, and if a fitting model is available from our distributors we\'ll add it to the store for you.</p>' +
          '<a href="https://calendly.com/exceptionalfire/expert-consultation" target="_blank" rel="noopener" class="ef-ff__btn">Get a Personal Match</a>' +
          '<p style="margin-top:12px"><a href="/pages/contact-us" style="text-decoration:underline">Contact support</a> &nbsp;·&nbsp; <a href="tel:+19496197824" style="text-decoration:underline">(949) 619-7824</a> &nbsp;·&nbsp; <a href="/collections/fireplaces" style="text-decoration:underline">Browse all fireplaces</a></p></div>';
        return;
      }
      resultsDiv.innerHTML = top.map(function(x){ return cardHTML(x.p); }).join('');
    }

    if(indexData) render();
    else {
      resultsDiv.innerHTML = '<p class="ef-ff__hint">Finding your matches…</p>';
      var tries = 0;
      var t = setInterval(function(){
        if(indexData || ++tries > 40){ clearInterval(t); render(); }
      }, 150);
    }
  }

  goTo(state.step);
})();
